import "./utils/silenceConsoleInProd";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import msalInstance, { initializeMsal } from "./Auth/Msal/msalInstance";
import { devError } from "./utils/devConsole";
import "./theme/css/base.css";
import "./theme/css/index.css";

// Inizializza MSAL
initializeMsal().then(() => {
  const rootElement = document.getElementById("root");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </BrowserRouter>
      </React.StrictMode>
    );
  } else {
    devError("Root element not found. Ensure the div with id 'root' exists in your HTML.");
  }
});
